import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
.parking{
  display: flex;
  flex-direction: column;
  color: ${theme.color['black']};
  .section-heading{
    display: flex;
    margin-top: ${toRem(-5)};
    .parking-policy-icon{
      &:before{
        margin-right: ${toRem(18)};
        position: relative;
        bottom: ${toRem(2)};
      }
    }
    .temp-icon{
      height: ${toRem(20)};
      padding-right: ${toRem(18)};
    }
    .parking-heading{
    }
  }
  &.parking-chat {
    .section-heading{
      padding: 0;
    }
    .parking-heading-chat{
      font-weight: 700 !important;
    }
  }
  .parking-information{
    margin-top: ${toRem(12)};
    padding-left: ${toRem(54)};
    .parking-item{
      margin-bottom: ${toRem(17)};
    }
  }
}
@media only ${theme.mediaQuery.smallerTablet} {
  .parking{
    display: flex;
    flex-direction: column;
    .section-heading{
      display: flex;
      margin-top: ${toRem(-5)};
      .parking-policy-icon{
        &:before{
          margin-right: ${toRem(18)};
        }
      }
      .temp-icon{
        height: ${toRem(20)};
        padding-right: ${toRem(18)};
      }
      .parking-heading{
      }
    }
    .parking-information{
      margin-top: ${toRem(12)};
      padding-left: ${toRem(45)};
      .parking-item{
        margin-bottom: ${toRem(12)};
      }
    }
  }
}
@media only ${theme.mediaQuery.allMobiles} {
  .parking{
    display: flex;
    flex-direction: column;
    .section-heading{
      display: flex;
      margin-top: ${toRem(-5)};
      padding: 0;
      .parking-policy-icon{
        margin-right: 0;
        &:before{
          margin-right: ${toRem(13)};
        }
      }
      .temp-icon{
        height: ${toRem(16)};
        padding-right: ${toRem(13)};
      }
      .parking-heading{
      }
    }
    .parking-information{
      margin-top: ${toRem(10)};
      padding-left: ${toRem(34)};
      .parking-item{
        margin-bottom: ${toRem(10)};
      }
    }
  }
}
.hqv-modal {
  &.parking{
    display: flex;
    flex-direction: column;
    .section-heading{
      display: flex;
      margin-top: ${toRem(24)};
      padding-left: 0;
      .parking-policy-icon{
        &:before{
          margin-right: ${toRem(18)};
        }
      }
      .temp-icon{
        height: ${toRem(20)};
        padding-right: ${toRem(18)};
      }
    }
    .parking-information{
      margin-top: ${toRem(12)};
      padding-left: ${toRem(48)};
      @media only ${theme.mediaQuery.allMobiles} {
        padding-left: ${toRem(35)};
      }
      @media only ${theme.mediaQuery.allTablets} {
        padding-left: ${toRem(40)};
      }
      .parking-item{
        margin-bottom: ${toRem(12)};
      }
    }
  }
}`}
`;
